import React, {useEffect, useState} from 'react'
import {Input} from "antd"

const InputSearch = (props) => {
    const {name, value, label} = props
    const [valueInput, _setValue] = useState(value)

    const _handleSetValue = () => {
        _setValue('')
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        const searchValue = value

        _setValue(value)

        props.onChange(name, searchValue)
    }

    useEffect(() => {
        props.value.length === 0 && _handleSetValue()
        // eslint-disable-next-line
    }, [props.value])

    return (
        <div className="InputSearch">
            <label htmlFor={name}>{label}</label>

            <Input
                id={name}
                name={name}
                value={valueInput}
                placeholder='Enter to search...'
                onChange={_handleChangeInput}
                style={{width: "100%"}}
            />
        </div>
    )
}

export default InputSearch
